import { AttributeType } from 'companySettings/enums';
import { IPartFinderAttributeValue, IPartFinderProductTypeAttribute } from 'companySettings/types';

// The product type an attribute a family inherits comes from, and the values it has: the drawer
// edits that attribute's values for the family, marks the ones the product type does not have as
// new and can write them back to the product type.
export interface IInheritedAttributeSource {
  productTypeName: string;
  values: IPartFinderAttributeValue[];
}

// Where an attribute's values come from: typed on the attribute, or seeded from a value list.
export enum AttributeValueSource {
  TYPED = 'typed',
  VALUE_LIST = 'value_list',
}

export interface IUpsertPartFinderProductTypeFormData {
  attributes: IPartFinderProductTypeAttribute[];
  name: string;
}

// An attribute as useFieldArray hands it out, keyed by the id it generates for the row.
export type IProductTypeAttributeField = Omit<IPartFinderProductTypeAttribute, 'id'> & {
  id: string;
};

// The `new*` fields hold the value being typed in before "+ Add" moves it into `values`.
// `saveAsListId` is the list the typed values go to; `createdListId` remembers the one the
// drawer created itself, which holds the values typed until then.
export interface IUpsertProductTypeAttributeFormData {
  name: string;
  newColorHex: string;
  newColorName: string;
  newListName: string;
  newRangeIncrement: string;
  newRangeMax: string;
  newRangeMin: string;
  newRangeUnit: string;
  newValue: string;
  saveAsList: boolean;
  source: AttributeValueSource;
  sourceAttributeId: number | null;
  sourceVersionNumber: number | null;
  type: AttributeType;
  updateList: boolean;
  values: IPartFinderAttributeValue[];
}
